import { Button, Col, Input, InputRef, Row, Space } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";
import * as Utils from "../utils/utils";
import * as String from "../commons/string";

import DataTable from "../components/DataTable";
import { ColumnsType, ColumnType } from "antd/lib/table";
import { FilterConfirmProps } from "antd/lib/table/interface";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

type DataIndex = keyof Types.CarDto;

function CarManagement() {
    const [orderCars, setOrderCars] = useState<Array<Types.CarDto>>([]);
    const [ezmobilityCars, setEzmobilityCars] = useState<Array<Types.CarDto>>([]);

    useEffect(() => {
        requestGetOrderCars();
    }, []);

    const requestAxiosGetOrderCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.CARS_URL);
        return response.data;
    };

    const {
        loading: loadingGetOrderCars,
        error: errorGetOrderCars,
        data: resultGetOrderCars,
        execute: requestGetOrderCars,
    } = useAsyncAxios(requestAxiosGetOrderCars);

    useEffect(() => {
        if (resultGetOrderCars === null) return;
        console.log("resultGetOrderCars", resultGetOrderCars);

        setOrderCars(resultGetOrderCars.cars);

        requestGetEzmobilityCars();
    }, [resultGetOrderCars]);

    useEffect(() => {
        if (errorGetOrderCars === null) return;

        console.log("errorGetOrderCars", errorGetOrderCars);
    }, [errorGetOrderCars]);

    const requestAxiosGetEzmobilityCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.EZMOBILITY_CARS_URL);
        return response.data;
    };

    const {
        loading: loadingGetEzmobilityCars,
        error: errorGetEzmobilityCars,
        data: resultGetEzmobilityCars,
        execute: requestGetEzmobilityCars,
    } = useAsyncAxios(requestAxiosGetEzmobilityCars);

    const checkOrderCarList = (car: Types.CarDto) => {
        const includeCarList = orderCars.filter((orderCar) => orderCar.fmsCarId === car.fmsCarId);

        if (includeCarList.length > 0) return true;
        else return false;
    };

    useEffect(() => {
        if (resultGetEzmobilityCars === null) return;

        console.log("resultGetEzmobilityCars", resultGetEzmobilityCars);

        const tempArray = [...resultGetEzmobilityCars.cars];
        tempArray.sort((a, b) => (checkOrderCarList(b) ? -1 : 1));
        const tempEzmobilityCars = tempArray.filter((car) => checkOrderCarList(car) === false);

        setEzmobilityCars(tempEzmobilityCars);
    }, [resultGetEzmobilityCars]);

    useEffect(() => {
        if (errorGetEzmobilityCars === null) return;

        console.log("errorGetEzmobilityCars", errorGetEzmobilityCars);
    }, [errorGetEzmobilityCars]);

    const requestAxiosAddCar = async (car: Types.CarDto) => {
        const response = await utilAxiosWithAuth().post(Request.CAR_URL, car);
        return response.data;
    };

    const { loading: loadingAddCar, error: errorAddCar, data: resultAddCar, execute: requestAddCar } = useAsyncAxios(requestAxiosAddCar);

    useEffect(() => {
        if (resultAddCar === null) return;
        console.log("resultAddCar", resultAddCar);

        requestGetOrderCars();
    }, [resultAddCar]);

    useEffect(() => {
        if (errorAddCar === null) return;

        console.log("errorAddCar", errorAddCar);
    }, [errorAddCar]);

    const onAddCar = (car: Types.CarDto) => {
        requestAddCar(car);
    };

    const requestAxiosDeleteCar = async (car: Types.CarDto) => {
        console.log("car", car, car.carId);
        const response = await utilAxiosWithAuth().delete(Request.CAR_URL + "/" + car.carId);
        return response.data;
    };

    const {
        loading: loadingDeleteCar,
        error: errorDeleteCar,
        data: resultDeleteCar,
        execute: requestDeleteCar,
    } = useAsyncAxios(requestAxiosDeleteCar);

    useEffect(() => {
        if (resultDeleteCar === null) return;
        console.log("resultDeleteCar", resultDeleteCar);

        requestGetOrderCars();
    }, [resultDeleteCar]);

    useEffect(() => {
        if (errorDeleteCar === null) return;

        console.log("errorDeleteCar", errorDeleteCar);
    }, [errorDeleteCar]);

    const onDeleteCar = (car: Types.CarDto) => {
        const orderCar = orderCars.filter((orderCar) => orderCar.fmsCarId === car.fmsCarId);
        orderCar.length > 0 && requestDeleteCar(orderCar[0]);
    };

    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef<InputRef>(null);

    const handleSearch = (selectedKeys: string[], confirm: (param?: FilterConfirmProps) => void, dataIndex: DataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText("");
    };

    const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<Types.CarDto> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: "block" }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        검색
                    </Button>
                    <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        초기화
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText((selectedKeys as string[])[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        필터
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        닫기
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            ),
    });

    const columnsEzmobility: ColumnsType<Types.CarDto> = [
        {
            align: "center",
            title: "차량관제 ID",
            dataIndex: "fmsCarId",
            key: "fmsCarId",
            sorter: (a, b, sortOrder) => Utils.sortNumber(a.fmsCarId.valueOf(), b.fmsCarId.valueOf(), sortOrder),
            ...getColumnSearchProps("fmsCarId"),
        },
        {
            align: "center",
            title: "차량번호",
            dataIndex: "carNumber",
            key: "carNumber",
            sorter: (a, b, sortOrder) => Utils.sortString(a.carNumber.valueOf(), b.carNumber.valueOf(), sortOrder),
            render: (_, row) => {
                if (row.carNumber) {
                    return row.carNumber;
                } else return String.dash;
            },
            ...getColumnSearchProps("carNumber"),
        },
        {
            align: "center",
            title: "제조사",
            dataIndex: "makerName",
            key: "makerName",
            sorter: (a, b, sortOrder) => Utils.sortString(a.makerName.valueOf(), b.makerName.valueOf(), sortOrder),
            render: (_, row) => {
                if (row.makerName) {
                    return row.makerName;
                } else return String.dash;
            },
            ...getColumnSearchProps("makerName"),
        },
        {
            align: "center",
            title: "등록",
            key: "add_fmsCarId",
            render: (_, row) => {
                return (
                    <Button
                        shape="round"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onAddCar(row);
                        }}
                    >
                        등록
                    </Button>
                );
            },
        },
    ];

    const columnsRuta40: ColumnsType<Types.CarDto> = [
        {
            align: "center",
            title: "차량 ID",
            dataIndex: "carId",
            key: "carId",
            sorter: (a, b, sortOrder) => Utils.sortNumber(a.carId.valueOf(), b.carId.valueOf(), sortOrder),
            ...getColumnSearchProps("carId"),
        },
        {
            align: "center",
            title: "차량번호",
            dataIndex: "carNumber",
            key: "carNumber",
            sorter: (a, b, sortOrder) => Utils.sortString(a.carNumber.valueOf(), b.carNumber.valueOf(), sortOrder),
            render: (_, row) => {
                if (row.carNumber) {
                    return row.carNumber;
                } else return String.dash;
            },
            ...getColumnSearchProps("carNumber"),
        },
        {
            align: "center",
            title: "제조사",
            dataIndex: "makerName",
            key: "makerName",
            sorter: (a, b, sortOrder) => Utils.sortString(a.makerName.valueOf(), b.makerName.valueOf(), sortOrder),
            render: (_, row) => {
                if (row.makerName) {
                    return row.makerName;
                } else return String.dash;
            },
            ...getColumnSearchProps("makerName"),
        },
        {
            align: "center",
            title: "삭제",
            key: "add_fmsCarId",
            render: (_, row) => {
                return (
                    <Button
                        shape="round"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDeleteCar(row);
                        }}
                    >
                        삭제
                    </Button>
                );
            },
        },
    ];

    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">차량 관리</h3>
                <Space direction="vertical" size={10} style={{ width: "100%" }}>
                    <Row gutter={20}>
                        <Col span={12}>
                            <h4 style={{ fontSize: "18px", fontWeight: "bold", margin: "20px 0" }}>ezMobility 등록차량</h4>
                            <DataTable hasScroll={false} columns={columnsEzmobility} rowKey="fmsCarId" dataSource={ezmobilityCars} />
                        </Col>
                        <Col span={12}>
                            <h4 style={{ fontSize: "18px", fontWeight: "bold", margin: "20px 0" }}>Ruta40 등록차량</h4>
                            <DataTable hasScroll={false} columns={columnsRuta40} rowKey="carId" dataSource={orderCars} />
                        </Col>
                    </Row>
                </Space>
            </Space>
        </div>
    );
}

export default CarManagement;
